import { Injectable } from '@angular/core';
import * as lodash from 'lodash';
import { ObjectUtils } from '../utils/Object.utils';
import { StringUtils } from '../utils/String.utils';
import * as jmespath from "jmespath";

@Injectable()
export class InterpolateService {
  static INTERPOLATION_REGEX: string = '\\$\\([^\\)]*\\)';
  static INTERPOLATION_JMES_REGEX: string = '\\$\\#\\([^\\)]*\\)';
  static INTERPOLATION_REGEX_KEY: string = '\\$\\(_key_\\)';
  static INTERPOLATION_REGEX_KEY_JMES: string = '\\$\\#\\(_key_\\)';
  static INTERPOLATION_REGEX_GROUP: string = '\\$\\(([^\\)]*)\\)';
  static INTERPOLATION_JMES_REGEX_GROUP: string = '\\$\\#\\(([^\\)]*)\\)';

  static INTERPOLATION_DEFAULT_OPTIONS: InterpolationOptions = {
    useEmptyValues: true,
    usePartialPath: true,
    clearUnresolvedPatterns: false
  };

  constructor() {
  }

  public static hasInterpolationString(string: string, key?: string): boolean {
    const regex = key
      ? InterpolateService.INTERPOLATION_REGEX_KEY.split('_key_').join(key.toLowerCase())
      : InterpolateService.INTERPOLATION_REGEX
    ;

    return typeof string === "string" ? (new RegExp(regex)).test(string.toLowerCase()) : false;
  }


  public static interpolate(interpolationString: string, values: any);
  public static interpolate(interpolationString: string, values: any, global: boolean);
  public static interpolate(interpolationString: string, values: any, global: boolean, additionalOptions: InterpolationOptions);
  public static interpolate(interpolationString: string, values: any | (string | number)[], global: boolean = false,
                            additionalOptions: InterpolationOptions = InterpolateService.INTERPOLATION_DEFAULT_OPTIONS) {
    try {
      let regex;
      const regexSuffix = global ? 'g' : '';

      if (values instanceof Array) {
        regex = new RegExp(InterpolateService.INTERPOLATION_REGEX, regexSuffix);

        for (const value of values) {
          interpolationString = interpolationString.replace(regex, value);
        }
      }
      else if (values && typeof values === 'object') {
        const groupingJMESRegex = new RegExp(InterpolateService.INTERPOLATION_JMES_REGEX, 'g');
        const valJMESRegex = new RegExp(InterpolateService.INTERPOLATION_JMES_REGEX_GROUP);
        const replaceValuesInStringJMES: Array<string> = interpolationString ? lodash.uniq(interpolationString.match(groupingJMESRegex)) : [];

        if (replaceValuesInStringJMES.length > 0) {
          for (const replaceValueInString of replaceValuesInStringJMES) {
            let grouping = valJMESRegex.exec(replaceValueInString);
            const conditionalInterpolation: Array<string> = grouping[1].split(' || ');
            const filteredValues = conditionalInterpolation.map(v => {
              try {
                let value=jmespath.search(values, v);

                return value ? value : "";
              } catch (err) {
                return "";
              }
            });

            let extractedValue = '';

            if (filteredValues.length > 0) {
              extractedValue = filteredValues[0];
            } else {
              break;
            }

            regex = InterpolateService.INTERPOLATION_REGEX_KEY_JMES.split('_key_').join(StringUtils.addEscapeCharacters(grouping[1]));
            regex = new RegExp(regex, regexSuffix);

            interpolationString = interpolationString.replace(regex, extractedValue);
            grouping = groupingJMESRegex.exec(interpolationString);
          }
        }

        const groupingRegex = new RegExp(InterpolateService.INTERPOLATION_REGEX, 'g');
        const valRegex = new RegExp(InterpolateService.INTERPOLATION_REGEX_GROUP);
        const replaceValuesInString: Array<string> = interpolationString ? lodash.uniq(interpolationString.match(groupingRegex)) : [];

        for (const replaceValueInString of replaceValuesInString) {
          let grouping = valRegex.exec(replaceValueInString);
          const conditionalInterpolation: Array<string> = grouping[1].split(' || ');
          const filteredValues = conditionalInterpolation
            .filter(v => ObjectUtils.pathValid(values, v, additionalOptions.useEmptyValues, additionalOptions.usePartialPath))
            .map(v => ObjectUtils.walk(values, v, additionalOptions.useEmptyValues, additionalOptions.usePartialPath));

          let extractedValue = '';

          if (filteredValues.length > 0) {
            extractedValue = filteredValues[0];
          } else {
            continue;
          }

          regex = InterpolateService.INTERPOLATION_REGEX_KEY.split('_key_').join(StringUtils.addEscapeCharacters(grouping[1]));
          regex = new RegExp(regex, regexSuffix);

          interpolationString = interpolationString.replace(regex, extractedValue);
          grouping = groupingRegex.exec(interpolationString);
        }
      }

      if (additionalOptions.clearUnresolvedPatterns) {
        interpolationString = interpolationString.replace(new RegExp(this.INTERPOLATION_REGEX, 'g'), '');
      }
    } catch (e) {
      console.error("Interpolation did not happen for "+interpolationString+ "in interpolate.service", e);
    }

    return interpolationString;
  }

  public interpolate(string: string, values: any);
  public interpolate(string: string, values: any, global: boolean);
  public interpolate(string: string, values: any, global: boolean, additionalOptions: InterpolationOptions);
  public interpolate(string: string, values: any, global?: boolean, additionalOptions?: InterpolationOptions) {
    return InterpolateService.interpolate(string, values, global, additionalOptions);
  }
}

export class InterpolationOptions {
  useEmptyValues?: boolean;
  usePartialPath?: boolean;
  clearUnresolvedPatterns?: boolean;
}


